export default __webpack_public_path__ + "static/media/67.64a68538.svg";